import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ClientWalkInModel } from '../model/index';

@Injectable()
export class ClientWalkInService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private clientWalkUrl = 'api/clientWalkIn';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getWalkInList(query: any): Promise<ClientWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.clientWalkUrl}/getWalkInList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    //
    // getJmsItemList(): Promise<any> {
    //     const url = `${this.skuUrl}/jmsItemList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }

    addUpdateWalkIn(pageData: any): Promise<any> {
        const url = `${this.clientWalkUrl}/addUpdateWalkIn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
        // return this.http
        //     .post(post, $.param(pageData))
        //     //.then(res => res.json() as any)
        //     .map(res => res.json())
        //     .catch(err => [JSON.parse(err._body)])
    }

    addUpdateWalkInPromo(pageData: any): Promise<any> {
        const url = `${this.clientWalkUrl}/addUpdateWalkInPromo`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    addUpdateHVSOAAppointment(pageData: any): Promise<any> {
        const url = `${this.clientWalkUrl}/addUpdateHVSOAAppointment`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    deleteWalkIn(walkInData: any): Promise<ClientWalkInModel> {
        const url = `${this.clientWalkUrl}/deleteWalkIn`;
        return this.http
            .post(url, $.param(walkInData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ClientWalkInModel)
            .catch(this.handleError);
    }
    saveTestBillGeneration(pageData: any): Promise<any> {
        const url = `${this.clientWalkUrl}/saveTestBillGeneration`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getLatestWalkInDetails(queryData: any): Promise<any> {
        const url = `${this.clientWalkUrl}/getLatestWalkInDetails`;
        let params: URLSearchParams = new URLSearchParams();
        for (let key in queryData) {
            params.set(key.toString(), queryData[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    /**
     * Get the last walk-in reference for a client to auto-populate Old Reference field
     */
    getLastWalkInReference(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.clientWalkUrl}/getLastWalkInReference`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<ClientWalkInModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/clientWalkIn.service.ts